// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"983fd42d","522":"a2ff95ab","545":"cdd2ccd6","551":"703e96ec","605":"3e0df2b9","662":"e94bb7df"}[chunkId] + ".chunk.js";
};